module.exports = __webpack_public_path__ + "media/images/badges/stride/milestone-3_active-7af78f889fd1e2a10deb27d0b46826ba.svg";